<div class="h-full min-h-0 flex flex-col justify-start items-center overflow-hidden gap-2">

    <!-- Header -->
    <div
        class="shrink-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
        <div class="flex flex-row items-center gap-x-2">
            <!-- <div class="grid grid-cols-1">
                <input id="brief-search" type="text" placeholder="Search" class="input-icon text-primary" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                    <path d="m21 21-4.34-4.34" />
                    <circle cx="11" cy="11" r="8" />
                </svg>
            </div> -->
        </div>

        <div class="hidden sm:block">
            <nav aria-label="Tabs" class="flex space-x-1">

                <a (click)="selectApproveStatus(TopRequestStatusEnum.All)"
                    class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center gap-x-1"
                    [class]="getApproveTabClass(TopRequestStatusEnum.All)">
                    All
                </a>

                <a (click)="selectApproveStatus(TopRequestStatusEnum.Created)"
                    class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center gap-x-1"
                    [class]="getApproveTabClass(TopRequestStatusEnum.Created)">
                    Waiting
                </a>

                <a (click)="selectApproveStatus(TopRequestStatusEnum.Approved)"
                    class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center gap-x-1"
                    [class]="getApproveTabClass(TopRequestStatusEnum.Approved)">
                    Approved
                </a>

                <a (click)="selectApproveStatus(TopRequestStatusEnum.Declined)"
                    class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center gap-x-1"
                    [class]="getApproveTabClass(TopRequestStatusEnum.Declined)">
                    Declined
                </a>


            </nav>
        </div>

    </div>
    <!-- Header - END -->

    <!-- Main Content -->
    <div class="flex-1 min-h-0 flex flex-col w-full overflow-hidden">
        @if (allTopupRequests() && allTopupRequests()!.length > 0) {
        <div class="w-full min-h-0 flex-1 flex flex-col overflow-hidden">
            <div class="flow-root flex-1 min-h-0 overflow-hidden">
                <div class="h-full min-h-0 overflow-x-auto">
                    <div class="inline-block min-h-0 h-full min-w-full align-middle">
                        <div class="data-table-wrapper h-full min-h-0 flex flex-col overflow-hidden">
                            <div class="overflow-y-auto flex-1 min-h-0 scrollbar-hide dark:bg-gray-800/50">
                                <table class="data-table min-w-full">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <th scope="col" class="text-left text-sm font-semibold">
                                                Brand
                                            </th>
                                            <th scope="col" class="text-left text-sm font-semibold">Requested By
                                            </th>
                                            <th scope="col" class="text-left text-sm font-semibold">Requested Date
                                            </th>
                                            <th scope="col" class="text-left text-sm font-semibold">Status
                                            </th>
                                            <th scope="col" class="text-left text-sm font-semibold">Amount
                                            </th>
                                            <th scope="col" class="text-right text-sm">
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        @for (request of allTopupRequests(); track request.id) {
                                        <tr>
                                            <td class="py-2 pr-3 text-sm whitespace-nowrap">
                                                <div class="flex items-center">
                                                    <div class="size-11 shrink-0">
                                                        <img [src]="imageService.getImageSource(request.businessAccount.companyLogo, 'gallery')"
                                                            alt=""
                                                            class="size-11 rounded-full dark:outline dark:outline-white/10" />
                                                    </div>
                                                    <div class="ml-4">
                                                        <div class="font-medium text-primary">
                                                            {{ request.businessAccount.companyName }}</div>
                                                        <div class="mt-1 text-secondary">
                                                            {{ request.businessAccount.id }}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td class="py-2 pr-3 text-sm whitespace-nowrap">
                                                <div class="flex items-center">
                                                    <div class="size-11 shrink-0">
                                                        <img [src]="imageService.getImageSource(request.requestedBy.photoURL, 'gallery')"
                                                            alt=""
                                                            class="size-11 rounded-full dark:outline dark:outline-white/10" />
                                                    </div>
                                                    <div class="ml-4">
                                                        <div class="font-medium text-primary">
                                                            {{ request.requestedBy.firstName }} {{
                                                            request.requestedBy.lastName.charAt(0) }}</div>
                                                        <div class="mt-1 text-secondary">
                                                            {{ request.requestedBy.firebaseUid }}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td class="px-3 py-5 text-sm whitespace-nowrap text-primary">{{
                                                formatService.getTimeSinceUpdated(request.createdDate) }}</td>

                                            <td
                                                class="px-3 py-5 text-sm whitespace-nowrap text-gray-500 dark:text-gray-400">
                                                <span
                                                    class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                                                    [class]="getStatusColour(request.status)">{{
                                                    getPayoutAttemptStatus(request.status) }}</span>
                                            </td>

                                            <td class="px-3 py-5 text-md font-medium whitespace-nowrap text-primary">
                                                {{ request.amount/100 | currency:
                                                request.businessAccount.currencyCode.toUpperCase() }}</td>

                                            <td class="px-3 py-5 flex flex-row items-center justify-end gap-x-4">

                                                @if (processingItems().includes(request.id)) {

                                                } @else {
                                                @if (request.status == TopRequestStatusEnum.Created ||
                                                request.status == TopRequestStatusEnum.Approved) {
                                                <button (click)="decline(request.id)" type="button"
                                                    class="rounded-full p-2 shadow-xs bg-red-50 text-red-700 inset-ring inset-ring-red-600/10 dark:bg-red-400/10 dark:text-red-400 dark:inset-ring-red-400/20">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" class="size-5">
                                                        <path d="M18 6 6 18" />
                                                        <path d="m6 6 12 12" />
                                                    </svg>
                                                </button>
                                                }

                                                @if (request.status == TopRequestStatusEnum.Created ||
                                                request.status == TopRequestStatusEnum.Declined) {
                                                <button (click)="approve(request.id)" type="button"
                                                    class="rounded-full p-2 shadow-xs bg-green-50 text-green-700 inset-ring inset-ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-400/20">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" class="size-5">
                                                        <path d="M20 6 9 17l-5-5" />
                                                    </svg>
                                                </button>
                                                }
                                                }
                                            </td>



                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        @else if (allTopupRequests() && allTopupRequests()!.length == 0) {
        <div class="w-full min-h-0 flex-1 flex items-center justify-center p-8 overflow-hidden">
            <div class="max-w-2xl text-center">
                <div
                    class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/20 mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-10 text-accent">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <circle cx="9" cy="7" r="4" />
                    </svg>
                </div>
                <h2 class="text-2xl font-semibold text-primary mb-4">Top-up Requests
                </h2>
                <p class="text-base text-secondary leading-relaxed ">
                    No top-up requests in the selected status. Update your filters to
                    see more requests.
                </p>
            </div>
        </div>
        }
        @else {
        <div class="w-full min-h-0 flex-1 flex flex-col overflow-hidden">
            <div class="flow-root flex-1 min-h-0 overflow-hidden">
                <div class="h-full min-h-0 overflow-x-auto">
                    <div class="inline-block min-h-0 h-full min-w-full align-middle">
                        <div class="data-table-wrapper h-full min-h-0 flex flex-col overflow-hidden">
                            <div class="overflow-y-auto flex-1 min-h-0 scrollbar-hide dark:bg-gray-800/50">
                                <table class="data-table min-w-full">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <th scope="col" class="text-left text-sm font-semibold">
                                                Creator</th>
                                            <th scope="col" class="text-left text-sm font-semibold">
                                                Rating
                                            </th>
                                            <th scope="col" class="text-left text-sm font-semibold">
                                                Videos
                                            </th>
                                            <th scope="col" class="text-left text-sm font-semibold">
                                                Status
                                            </th>
                                            <th scope="col" class="text-right text-sm">
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        @for (skeleton of [1, 2, 3, 4, 5]; track
                                        skeleton) {
                                        <tr>
                                            <td class="text-sm font-medium whitespace-nowrap">
                                                <div class="flex items-center">
                                                    <div
                                                        class="size-20 shrink-0 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse">
                                                    </div>
                                                    <div class="ml-4 flex-1">
                                                        <div
                                                            class="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mb-2">
                                                        </div>
                                                        <div class="flex flex-row gap-x-2">
                                                            <div
                                                                class="h-3 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse">
                                                            </div>
                                                            <div
                                                                class="h-3 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-sm whitespace-nowrap">
                                                <div class="flex h-full items-center">
                                                    <div
                                                        class="h-8 w-12 bg-gray-200 dark:bg-gray-700 rounded animate-pulse">
                                                    </div>
                                                </div>
                                            </td>

                                            <td class="text-sm whitespace-nowrap">
                                                <div class="flex flex-row gap-x-0">
                                                    <div
                                                        class="h-8 w-16 bg-gray-200 dark:bg-gray-700 rounded-l-md animate-pulse">
                                                    </div>
                                                    <div class="h-8 w-16 bg-gray-200 dark:bg-gray-700 animate-pulse">
                                                    </div>
                                                    <div
                                                        class="h-8 w-16 bg-gray-200 dark:bg-gray-700 rounded-r-md animate-pulse">
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-sm whitespace-nowrap">
                                                <div class="flex flex-col gap-y-2">
                                                    <div
                                                        class="h-6 w-20 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse">
                                                    </div>
                                                    <div
                                                        class="h-3 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse">
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-right text-sm font-medium whitespace-nowrap">
                                                <div
                                                    class="h-8 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse ml-auto">
                                                </div>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
    <!-- Main Content - END -->
</div>